import { render, staticRenderFns } from "./descritionsTooltip.vue?vue&type=template&id=7e13bfb7&scoped=true"
import script from "./descritionsTooltip.vue?vue&type=script&lang=js"
export * from "./descritionsTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e13bfb7",
  null
  
)

export default component.exports